export default "__VITE_ASSET__CxBd7SJw__"